import { getPayments } from "common/services/payments.service";
import React, { useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { setLoading } from "slices/search/reducer";

const AligningWidget = ({ activeTab }: any) => {
  const [aligningSupport, setAligningSupport] = useState(0);
  const [totalSupport, setTotalSupport] = useState(0);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        // Simulate fetching data
        const response: any = await getPayments({
          filters: {
            isSalaryAligned: true,
            $or: [
              {
                startDate: {
                  $between: ["2017-01-01", `${new Date().getFullYear()}-12-31`],
                },
              },
              {
                endDate: {
                  $between: ["2017-01-01", `${new Date().getFullYear()}-12-31`],
                },
              },
            ],
          },
        });
        setAligningSupport(response?.meta?.pagination?.total || 0);
      } catch (error) {
        console.warn("Error fetching aligning support", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [activeTab]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        // Simulate fetching data
        const response: any = await getPayments({
          filters: {
            $or: [
              {
                startDate: {
                  $between: ["2017-01-01", `${new Date().getFullYear()}-12-31`],
                },
              },
              {
                endDate: {
                  $between: ["2017-01-01", `${new Date().getFullYear()}-12-31`],
                },
              },
            ],
          },
        });
        setTotalSupport(response?.meta?.pagination?.total || 0);
      } catch (error) {
        console.warn("Error fetching aligning support", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const percentageValue = useMemo(() => {
    if (totalSupport === 0) return 0;
    return (aligningSupport / totalSupport) * 100;
  }, [aligningSupport, totalSupport]);

  return (
    <div className="p-3 border border-dashed border-start-0">
      <h5 className="mb-1">
        <span className="counter-value" data-target="92.54">
          <CountUp
            start={0}
            end={percentageValue}
            decimals={0}
            suffix={"%"}
            duration={1}
          />
        </span>
      </h5>
      <p className="text-muted mb-0">% Aligned to Salary Scale</p>
    </div>
  );
};

export default AligningWidget;
